{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "retry": "Try again",
    "loadMore": "Load more",
    "clearFilters": "Clear filters",
    "close": "Close",
    "search": "Search",
    "refresh": "Refresh",
    "edit": "Edit",
    "copy": "Copy",
    "copied": "Copied"
  },
  "theme": {
    "label": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "operators": {
    "bank": "Bank transfer"
  },
  "language": {
    "label": "Language",
    "en": "English",
    "fr": "French",
    "endonym": {
      "fr": "Français",
      "en": "English"
    },
    "switchTo": "Show this page in French"
  },
  "permissionDenied": {
    "title": "You do not have access to this",
    "body": "Ask an administrator to grant the permission below if you need it."
  },
  "states": {
    "loading": "Loading",
    "emptyTitle": "Nothing here yet",
    "filteredEmptyTitle": "Nothing matched those filters",
    "filteredEmptyBody": "Try removing a filter to widen the search.",
    "errorTitle": "Something went wrong",
    "offlineTitle": "You appear to be offline",
    "offlineBody": "Check your connection and try again.",
    "serverErrorBody": "This is our fault, not yours. Trying again often works.",
    "requestId": "Reference",
    "yes": "Yes",
    "no": "No"
  },
  "notFound": {
    "title": "Page not found",
    "body": "The page you asked for does not exist, or you no longer have access to it."
  },
  "totp": {
    "qrAlt": "QR code for two-factor authentication setup",
    "manualEntry": "Or enter this code manually:",
    "code": "Authentication code",
    "submit": "Verify and continue",
    "wrongCode": "That code was not accepted. Check the time on your device and try again.",
    "recoveryWarning": "These codes are shown only once and are not stored anywhere you can retrieve them again. Save them somewhere safe before continuing.",
    "recoveryAck": "I have saved these codes",
    "recoveryCodes": "Recovery codes",
    "recoveryDownload": "Download (.txt)",
    "copyFailed": "The browser refused to copy. Download the codes instead."
  },
  "responsive": {
    "title": "Best on a larger screen",
    "body": "This screen is built for a bigger display. Use a tablet or desktop, or head back to the Overview for what's available on a phone.",
    "backToOverview": "Back to Overview"
  },
  "segments": {
    "summary_one": "{{length}} characters · {{count}} segment ({{encoding}})",
    "summary_other": "{{length}} characters · {{count}} segments ({{encoding}})"
  },
  "phone": {
    "placeholder": "6XX XXX XXX"
  },
  "proof": {
    "chooseFile": "Choose a file",
    "hint": "PDF, PNG or JPEG, up to 5 MB",
    "errorType": "Choose a PDF, PNG or JPEG file.",
    "errorSize": "This file is larger than 5 MB.",
    "uploading": "Uploading proof"
  },
  "progress": {
    "unlimited": "Unlimited"
  },
  "onlineDot": {
    "online": "Online",
    "offline": "Offline"
  },
  "idle": {
    "title": "You will be signed out soon",
    "body": "Nothing has happened here for 25 minutes. To protect your account, you will be signed out in 5 minutes.",
    "stay": "Stay signed in",
    "signOut": "Sign out now"
  },
  "stepUp": {
    "title": "Confirm it’s you",
    "body": "This action needs your password again.",
    "bodyTotp": "This action needs your password and a code from your authenticator app.",
    "password": "Password",
    "code": "Verification code",
    "recoveryCode": "Recovery code",
    "useRecovery": "Use a recovery code instead",
    "useApp": "Use a code from the app instead",
    "confirm": "Confirm",
    "confirming": "Checking…",
    "cancel": "Cancel"
  },
  "range": {
    "label": "Period",
    "7d": "7 days",
    "30d": "30 days",
    "90d": "90 days",
    "custom": "Custom",
    "from": "From",
    "to": "To",
    "apply": "Apply",
    "order": "Pick a start day on or before the end day.",
    "tooLong": "A period spans at most {{days}} days.",
    "dialog": "Custom period"
  },
  "summary": {
    "noComparison": "No comparison",
    "points": "{{value}} pts"
  },
  "authShowcase": {
    "eyebrow": "SMS gateway",
    "headline": "Turn your Android phones into an SMS gateway.",
    "lead": "Send and receive SMS from your own SIM cards through a simple API, and watch every message arrive.",
    "features": {
      "sims": {
        "title": "Your SIMs, your numbers",
        "body": "Messages leave from the phones you connect."
      },
      "api": {
        "title": "REST API and webhooks",
        "body": "Integrate in minutes; every reply reaches you in real time."
      },
      "delivery": {
        "title": "Delivery you can see",
        "body": "Each message tracked from sent to delivered."
      }
    },
    "delivered": "Delivered"
  },
  "hiis": {
    "label": "HIIS, the company behind DevSMS",
    "byline": "DevSMS by HIIS"
  },
  "footer": {
    "label": "Useful links",
    "download": "Download the Android app",
    "status": "Service status",
    "support": "Support",
    "apiGuide": "API guide",
    "privacy": "Privacy",
    "refundPolicy": "Refund policy"
  }
}
